import gql from 'graphql-tag'

export const getUserForAuthenticatedCheckQuery = gql`
  query GetUserProfile {
    getUserProfile {
      id
    }
  }
`
